{
  "id": 13,
  "location": "cafe",
  "difficulty": "normal",
  "moves": 27,
  "kinds": 6,
  "goals": [
    { "type": "collect", "kind": "cookie", "count": 26 },
    { "type": "collect", "kind": "donut", "count": 26 }
  ],
  "stars": [2950, 3770],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . # # . . .",
    ". . . # # . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.89, "movesLeft": 7.8, "closeLosses": 0.053, "target": 0.85 }
}
